export default (params) => ({
  trigger: {
    name: 'second_chance_disclamer.read_more',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_more',
      params: {
        sub_feature: null,
      },
    },
  },
});
